import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { dispatch, useGlobalState } from '../../store/state';
import { Col, message, Result, Skeleton, Statistic } from 'antd';
import BaseLayoutComponent from '../../components/Layout/Admin/BaseLayoutComponent';
import CurrencyIcon from '../../components/Common/CurrencyIcon';
import InfoStatComponent from '../../components/Admin/Home/InfoStatComponent';
import { GiReceiveMoney } from 'react-icons/gi';
import { AiOutlineNotification, AiOutlineTags } from 'react-icons/ai';
import { BsPeople } from 'react-icons/bs';
import OverallProgressComponent from '../../components/Admin/Home/OverallProgressComponent';
import CampaignStatsComponent from '../../components/Admin/Home/CampaignStatsComponent';
import CampaignClosedComponent from '../../components/Admin/Home/CampaignClosedComponent';
import InfluencerApprovalsComponent from '../../components/Admin/Home/InfluencerApprovalsComponent';
import WithdrawalsComponent from '../../components/Admin/Home/WithdrawalsComponent';
import { GetHomeBasicsInfo } from '../../apis/Admin/Home/GetHomeBasicsInfo';

// const { Header, Sider, Content } = Layout;
export const AdminHomePage = () => {
  const [user] = useGlobalState('user');
  const [baseInfo, setBaseInfo] = useState({});

  const getHomeInfo = () =>{
    GetHomeBasicsInfo(user.accessToken).then(({ status, response })=>{
      if (status=== 200) {
        setBaseInfo({ ...response });
      }
    });
  };

  useEffect(()=>{
    getHomeInfo();
  }, []);


  return (
    <BaseLayoutComponent>
      {/* <TopSubHeaderComponent className="p-3 sticky">
                <h6 className="m-0">Hello {user.firstname}</h6>
            </TopSubHeaderComponent> */}
      <div className="d-flex flex-wrap my-2 px-2">
        <InfoStatComponent className="col-md-3 my-2 px-2"
          title="Total Flynt Earnings"
          currency={CurrencyIcon()}
          value={baseInfo.totalEarnings || 0}
          icon={<GiReceiveMoney/>}
        />
        <InfoStatComponent className="col-md-3 my-2 px-2"
          title="Total Number of Brands"
          value={baseInfo.brands || 0}
          valueOf="Brands"
          icon={<AiOutlineTags/>}
        />
        <InfoStatComponent className="col-md-3 my-2 px-2"
          title="Total Number of Influencers"
          value={baseInfo.influencers || 0}
          valueOf="Influencers"
          icon={<BsPeople/>}
        />
        <InfoStatComponent className="col-md-3 my-2 px-2"
          title="Completed Campaigns"
          value={baseInfo.closedCampaigns || 0}
          valueOf="Campaigns"
          icon={<AiOutlineNotification/>}
        />
        <OverallProgressComponent className="col-md-12 my-2 px-2"/>
        <CampaignStatsComponent className="col-md-6 my-2 px-2"/>
        <CampaignClosedComponent className="col-md-6 my-2 px-2"/>
        <InfluencerApprovalsComponent className="col-md-6 my-2 px-2"/>
        <WithdrawalsComponent className="col-md-6 my-2 px-2"/>
      </div>
    </BaseLayoutComponent>
  );
};
